import { useMutation, useQueryClient } from '@tanstack/react-query';
import { commentsApi, type CommentScope, type MentionUser } from '../api/commentsApi';

interface UseAddCommentOptions {
  scope?: CommentScope;
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}

interface AddCommentInput {
  text: string;
  mentions: MentionUser[];
}

export const useAddComment = (issueKey: string, options: UseAddCommentOptions = {}) => {
  const queryClient = useQueryClient();
  const { scope = 'user', onSuccess: onSuccessCallback, onError: onErrorCallback } = options;

  return useMutation({
    mutationFn: ({ text, mentions }: AddCommentInput) => commentsApi.addComment(issueKey, text, mentions, scope),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['comments', issueKey] });
      if (onSuccessCallback) {
        onSuccessCallback();
      }
    },
    onError: (error: Error) => {
      console.error('Error adding comment:', error);
      if (onErrorCallback) {
        onErrorCallback(error);
      }
    },
  });
};
